import { HStack, Stack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { object as yupObject, string as yupString } from "yup";
import ProceedCancelButtons from "components/Button/ProceedCancelButtons";
import { FloatingField } from "design-system";
import { NewHireJourney } from "models/v2/newHireJourney";
import { apiNewHireListPath } from "helpers/url/api/v2";
import { useAddPathToNewHire } from "features/Path/hooks";

const addPathToNewHireSchema = yupObject({
  newHireJourneyId: yupString().label("New Hire to Assign Path").required(),
});

interface AddPathToNewHireFormProps {
  pathId: string;
  onClose: () => void;
}

export default function AddPathToNewHireForm({ pathId, onClose }: AddPathToNewHireFormProps) {
  const { mutate: addPathToNewHire, isPending } = useAddPathToNewHire(pathId, onClose);
  const {
    control,
    formState: { errors, isDirty },
    handleSubmit,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(addPathToNewHireSchema),
  });

  return (
    <>
      <Stack alignItems="start">
        <Stack width="60%" alignItems="start">
          <FloatingField name="newHireJourneyId" errors={errors.newHireJourneyId?.message}>
            <FloatingField.Label>New Hire to Assign Path</FloatingField.Label>
            <FloatingField.SingleSelect<NewHireJourney>
              control={control}
              name="newHireJourneyId"
              fetchPath={apiNewHireListPath()}
              extractValue={(v: NewHireJourney) => v.id}
              embedOption={(v) => ({
                value: v.id,
                label: `${v.newHire.fullName} (${v.newHire.workEmail || "No Email"})`,
                rawValue: v,
              })}
            />
          </FloatingField>
        </Stack>
      </Stack>
      <HStack mt={12} justify="end">
        <ProceedCancelButtons
          handleSubmit={handleSubmit(addPathToNewHire)}
          onClose={onClose}
          proceedText="Assign"
          proceedDisabled={!isDirty}
          isLoading={isPending}
        />
      </HStack>
    </>
  );
}
